import React, { useState } from 'react'
import './CommunicationBlock.css'
import communicationBg from '../../asset/main-slider/communication.avif'
import { submitOrder } from '../../api'

const CommunicationBlock = () => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [isSent, setIsSent] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setIsSubmitting(true)
    try {
      await submitOrder({ name, phone, serviceName: 'Расчёт стоимости' })
      setIsSent(true)
      setName('')
      setPhone('')
    } catch (err) {
      setError('Не удалось отправить заявку. Попробуйте ещё раз')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section
      className="communication-cta"
      style={{ backgroundImage: `url(${communicationBg})` }}
      aria-label="Форма заявки на расчет стоимости"
    >
      <div className="communication-cta__overlay">
        <div className="communication-cta__content">
          <h2 className="communication-cta__title">
            Рассчитать
            <br />
            стоимость
          </h2>
          <p className="communication-cta__description">
            Оставьте свой номер телефона и наш менеджер свяжется с вами в ближайшее время
          </p>

          {isSent ? (
            <p className="communication-cta__description">
              Заявка отправлена, наш менеджер свяжется с вами в ближайшее время
            </p>
          ) : (
            <form className="communication-cta__form" onSubmit={handleSubmit}>
              <label className="communication-cta__field">
                <span className="communication-cta__label">Ваше имя</span>
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </label>

              <label className="communication-cta__field">
                <span className="communication-cta__label">Номер телефона</span>
                <input
                  type="tel"
                  name="phone"
                  autoComplete="tel"
                  required
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </label>

              {error && <p className="communication-cta__error">{error}</p>}

              <button type="submit" className="communication-cta__button" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : 'Получить консультацию'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}

export default CommunicationBlock